<div class="input-group bc_input-group"
     [class.dropdown]="mode !== 'sync'"
     [class.opened]="states.showList">
  <input type="text"
         class="form-control input_field"
         name="select"
         [attr.data-tests-id]="'bc-select-' + id"
         [id]="id"
         [placeholder]="placeholder || ''"
         [disabled]="disable"
         (keyup)="keyUp($event)"
         (keydown)="checkTab($event)"
         (focus)="focus()"
         (click)="focus()"
         (blur)="blur()"
         [readonly]="!searchAvailable"
         autocomplete="off"
         #searchInput>
  <div *ngIf="plugin" data-tests-id="bc-select-search-icon" class="input-group-addon bc-btn bc-btn_custom bc-btn_search"
          (click)="search()" [class.bc-btn_disable]="disable">
    <svg class="bc-btn_search__icon svg-icon" width="15" height="16">
      <use xlink:href="#search-icon"></use>
    </svg>
  </div>

  <div *ngIf="mode !== 'sync'" class="input-group-addon u-unstyled-btn dropdown-toggle"
       (click)="toogleFocus()" [class.opened]="states.showList">
    <svg class="bc-dropdown__icon svg-icon" width="14" height="8">
      <use xlink:href="#dropdown-icon"></use>
    </svg>
  </div>
</div>

<ul class="u-unstyled-list" [class.opened]="states.showList">
  <li *ngFor="let item of filteredList; let i = index;">
    <div class="selectable"
         [attr.data-tests-id]="'bc-select-' + id + '-value-' + i"
         (click)="select(item, i)"
         [class.selected]="states.index == i"
         [class.border-bottom]="item.highlighted">
      <ng-template *ngIf="iteratedTemplate" [ngTemplateOutlet]="iteratedTemplate" [ngTemplateOutletContext]="{item: item}"></ng-template>
      <ng-container *ngIf="!iteratedTemplate">{{ item.name }}</ng-container>
    </div>
  </li>
</ul>
